import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

// Check if a path is an auth page (should not be redirected back to auth page)
const isAuthRoute = (path: string): boolean => {
  if (!path || path === '/' || path === '/login') {
    return true;
  }
  return /(^|\/)(login|register|forgot-password|reset-password|check-mail|invalid-code|verify-otp)($|\?|\/)/i.test(path);
};

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const fromPath = location?.state?.from;
      // Only redirect to the previous path if it's not an auth route
      let redirectPath = fromPath && !isAuthRoute(fromPath) ? fromPath : APP_DEFAULT_PATH;

      if (user?.userType === 2 && redirectPath === APP_DEFAULT_PATH) {
        redirectPath = '/tenant-dashboard';
      } else if (user?.userType === 4 && redirectPath === APP_DEFAULT_PATH) {
        redirectPath = '/contractor-dashboard';
      }

      navigate(redirectPath, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location, user]);

  return children;
}
